export const legalEntities = {
  "legalEntity.russianFrmoOid": "OID медицинской организации (ФРМО)",
  "legalEntity.russianFrmoOidHint": "Необязательный идентификатор российской медорганизации в ФРМО Минздрава. Нужен только при формировании документа ЕГИСЗ.",
  "legalEntity.russianRegionCode": "Регион адреса в РФ (код ФНС)",
  "legalEntity.russianOgrn": "ОГРН организации",
  "legalEntity.title": "Юридические лица",
  "legalEntity.subtitle": "Реестр юридических лиц этой клиники.",
  "legalEntity.create": "Добавить юридическое лицо",
  "legalEntity.open": "Открыть {name}",
  "legalEntity.actions": "Действия",
  "legalEntity.legalName": "Точное юридическое наименование",
  "legalEntity.publicName": "Публичное название",
  "legalEntity.shortName": "Краткое название для интерфейса",
  "legalEntity.publicNameHint": "Необязательно. Используется в заголовке и при выборе организации; если не задано — показывается полное юридическое наименование. В новых печатных документах и ЕГИСЗ используется полное наименование.",
  "legalEntity.kind": "Тип",
  "legalEntity.organization": "Организация",
  "legalEntity.individual_business": "Индивидуальный предприниматель",
  "legalEntity.lifecycle": "Состояние",
  "legalEntity.active": "Активно",
  "legalEntity.archived": "В архиве",
  "legalEntity.current": "Текущая редакция",
  "legalEntity.historyOption": "{revision} · действовала до {until} · {author}",
  "legalEntity.historyOptionUnattributed": "{revision} · действовала до {until}",
  "legalEntity.archive": "В архив",
  "legalEntity.restore": "Восстановить",
  "legalEntity.save": "Сохранить",
  "legalEntity.saving": "Сохранение…",
  "legalEntity.loading": "Загрузка юридических лиц…",
  "legalEntity.empty": "Юридических лиц пока нет",
  "legalEntity.emptyDetail": "Добавьте организацию или индивидуального предпринимателя в реестр клиники.",
  "legalEntity.loadFailed": "Не удалось загрузить юридические лица.",
  "legalEntity.forbidden": "Нет доступа к юридическим лицам.",
  "legalEntity.readOnly": "Редакция только для чтения",
  "legalEntity.failed": "Изменение не сохранено. Ваш черновик сохранён в форме.",
  "legalEntity.invalid": "Проверьте поля и сроки действия. Изменение не сохранено.",
  "legalEntity.duplicate": "Этот налоговый идентификатор уже есть в реестре клиники, возможно в архиве.",
  "legalEntity.conflict": "Запись изменилась. Загрузите и проверьте последнюю редакцию перед сохранением своего черновика.",
  "legalEntity.lifecycleConflict": "Текущее состояние записи не допускает это действие. Загрузите актуальную редакцию.",
  "legalEntity.reload": "Загрузить последнюю редакцию",
  "legalEntity.latest": "Последние сохранённые данные",
  "legalEntity.unsaved": "Черновик юридического лица",
  "legalEntity.unsavedPublicName": "Черновик публичного названия",
  "legalEntity.comment": "Комментарий",
  "legalEntity.validFrom": "Действует с",
  "legalEntity.validTo": "Действует по",
  "legalEntity.taxNone": "Без налогового идентификатора",
  "legalEntity.recordedAt": "Дата записи"
} as const
